import { useContext } from "react";
import { PendingDealersActionContext } from "./PendingDealersActionContext";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { getApi } from "@beeldit/core/helpers/api";

function useGetPendingDealers() {
  const { setCount } = useContext(PendingDealersActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any = (data: any) => data) => {
    getApi()
      .get(`/users/dealers/pending`)
      .then((response: any) => {
        const raw = response.data;
        const value =
          typeof raw === "number"
            ? raw
            : typeof raw === "object" && raw !== null && "count" in raw
            ? raw.count
            : 0;
        const data = onSuccess(value);
        setCount(data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGetPendingDealers;
